export default __webpack_public_path__ + "static/media/file.46235552.svg";